import { render, staticRenderFns } from "./28_main.vue?vue&type=template&id=4940d8e1"
import script from "./28_main.vue?vue&type=script&lang=js"
export * from "./28_main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports